export default function Traits() {
    return (
        <>
            <p>Your character has six traits that represent their physical, mental, and social aptitude.</p>
            <ul>
                <li><strong><h4 id="trait-agility" className="inline-heading">Agility</h4></strong> <span>(Use it to Sprint, Leap, Maneuver,etc.)</span>
                    <p>A high Agility means you’re fast on your feet, nimble on
                        difficult terrain, and quick to react to danger. You’ll make
                        an Agility Roll to scurry up a rope, sprint to cover, or
                        bound from rooftop to rooftop.</p></li>
                <li><strong><h4 id="trait-strength" className="inline-heading">Strength</h4></strong> <span>(Use it to Lift, Smash, Grapple, etc.)</span>
                    <p>A high Strength means you’re better at feats that test your
                        physical prowess and stamina. You’ll make a Strength Roll
                        to break through a door, lift heavy objects, or hold your
                        ground against a charging foe.</p></li>
                <li><strong><h4 id="trait-finesse" className="inline-heading">Finesse</h4></strong> <span>(Use it to Control, Hide, Tinker, etc.)</span>
                    <p>A high Finesse means you’re skilled at tasks that require
                        accuracy, stealth, or the utmost control. You’ll make a
                        Finesse Roll to use fine tools, escape notice, or strike with
                        precision.</p></li>
                <li><strong><h4 id="trait-instinct" className="inline-heading">Instinct</h4></strong> <span>(Use it to Perceive, Sense, Navigate, etc.)</span>
                    <p>A high Instinct means you have a keen sense of your
                        surroundings and a natural intuition. You’ll make an
                        Instinct Roll to sense danger, notice details in the world
                        around you, or track an elusive foe.</p></li>
                <li><strong><h4 id="trait-presence" className="inline-heading">Presence</h4></strong> <span>(Use it to Charm, Perform, Deceive, etc.)</span>
                    <p>A high Presence means you have a strong force of
                        personality and a facility for social situations. You’ll make
                        a Presence Roll to plead your case, intimidate a foe, or
                        capture the attention of a crowd.</p></li>
                <li><strong><h4 id="trait-knowledge" className="inline-heading">Knowledge</h4></strong> <span>(Use it to Recall, Analyze, Comprehend, etc.)</span>
                    <p>A high Knowledge means you know information others
                        don’t and understand how to apply your mind through
                        deduction and inference. You’ll make a Knowledge Roll
                        to interpret facts, see the patterns clearly, or remember
                        important information.</p></li>
            </ul>

        </>
    );
}